module.exports = __webpack_public_path__ + "h5/img/h5-bg.d2a454d9.jpg";